import axios from "../utils/axios";

export const getAllMarkets = async (
  assignMarket,
  neglectAllCondition = false,
  excludeDemo = true // new param, defaults to true
) => {
  const response = await axios.get(`/market/all`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    params: {
      assignMarket,           // boolean
      neglectAllCondition,    // boolean
      excludeDemo             // boolean (true excludes DEMO/SAMPLE; false includes)
    },
  });
  return response;
};

export const addStoreMarket = async (payload) => {
  const response = await axios.post(`/market/add-store`, payload, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return response;
};

export const getStoreMarkets = async () => {
  const response = await axios.get(`/market/store_market`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return response;
};
